import { useCurrentUser } from 'api/hooks/useCurrentUser';
import { useEffect } from 'react';
import * as Sentry from '@sentry/react';

export const useUpdateSentryUser = () => {
  const { data: user } = useCurrentUser();

  useEffect(() => {
    if (user) {
      Sentry.setUser({
        id: user.userId,
        email: user.email,
        extra: {
          tenantName: user.tenantName,
          location: user.location.name,
          region: user.location.region,
        },
      });
    } else {
      Sentry.setUser(null);
    }
  }, [user]);
};
